const auditLogTypesAllReducer = (state = [{code: "all", description: "All"}], action) => {
  switch (action.type) {
    case 'LANDNOTIFICATION_AUDIT_LOG_TYPES_ALL':
      return action.results;
    default:
      break;
  }
  return state;
}

export default auditLogTypesAllReducer;